/* ============================================================
   FAQページ タブ＋アコーディオン
   - 管理画面ページ本文(HTML)を読み取り、見出し構造からタブ＋アコーディオンを自動生成
     ・H2 = カテゴリ（タブ）
     ・H3 = 質問
     ・H3 以降〜次のH3/H2まで = 回答
   - ページ本文が無い場合（フォールバックのセクションブロック描画）も、そのまま開閉/切替を有効化
   ============================================================ */
(function () {
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  // ページ本文(H2/H3構造)から タブ＋アコーディオンのマークアップを生成
  function buildFromRich(rich) {
    var cats = [];
    var curCat = null, curItem = null;
    Array.prototype.forEach.call(rich.children, function (node) {
      var tag = node.tagName;
      if (tag === 'H2') {
        curCat = { label: node.textContent.trim(), items: [] };
        cats.push(curCat); curItem = null;
      } else if (tag === 'H3') {
        if (!curCat) { curCat = { label: '', items: [] }; cats.push(curCat); }
        curItem = { q: node.innerHTML, a: '' };
        curCat.items.push(curItem);
      } else if (curItem) {
        curItem.a += node.outerHTML; // 回答（複数要素を連結）
      }
    });
    // 質問が1つも無ければ変換しない（素のHTMLをそのまま表示）
    var total = cats.reduce(function (n, c) { return n + c.items.length; }, 0);
    if (!total) return false;

    var tabs = el('div', 'faq-toggle-buttons');
    var sections = [];
    cats.forEach(function (c, i) {
      var key = 'cat' + i;
      var btn = el('button', 'faq-tab-button' + (i === 0 ? ' active' : ''),
        (c.label || ('カテゴリ' + (i + 1))) + '（' + c.items.length + '）');
      btn.setAttribute('type', 'button');
      btn.setAttribute('data-tab', key);
      tabs.appendChild(btn);

      var sec = el('div', 'faq-section' + (i === 0 ? ' active' : ''));
      sec.setAttribute('data-category', key);
      if (c.label) sec.appendChild(el('h3', 'faq-category', c.label));
      c.items.forEach(function (it) {
        var item = el('div', 'faq-item');
        var q = el('button', 'faq-question', it.q);
        q.setAttribute('type', 'button');
        item.appendChild(q);
        item.appendChild(el('div', 'faq-answer', it.a));
        sec.appendChild(item);
      });
      sections.push(sec);
    });

    rich.innerHTML = '';
    rich.appendChild(tabs);
    sections.forEach(function (s) { rich.appendChild(s); });
    rich.removeAttribute('data-faq-rich');
    return true;
  }

  function bindHandlers(wrapper) {
    // タブ切替
    wrapper.querySelectorAll('.faq-tab-button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        wrapper.querySelectorAll('.faq-tab-button').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var tab = btn.getAttribute('data-tab');
        wrapper.querySelectorAll('.faq-section').forEach(function (sec) {
          sec.classList.toggle('active', sec.getAttribute('data-category') === tab);
        });
        // タブ切替時にアコーディオンを閉じる
        wrapper.querySelectorAll('.faq-question.active').forEach(function (q) { q.classList.remove('active'); });
      });
    });
    // アコーディオン開閉
    wrapper.querySelectorAll('.faq-question').forEach(function (q) {
      q.addEventListener('click', function () { q.classList.toggle('active'); });
    });
  }

  function init() {
    var wrapper = document.querySelector('.faq-wrapper');
    if (!wrapper) return;
    var rich = wrapper.querySelector('[data-faq-rich]');
    if (rich && rich.children.length) {
      buildFromRich(rich);
    }
    bindHandlers(wrapper);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
